import React, { memo, useState } from "react";
import "./CustomBookmark.css";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark } from "@fortawesome/pro-regular-svg-icons";
import { faBookmark as faBookmarkOnHover } from "@fortawesome/pro-solid-svg-icons";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";

interface BookmarkProps {
    action: () => void;
    tooltipMessage: string;
    userId: number | undefined;
}

const SaveBookmark: React.FC<BookmarkProps> = memo((props) => {
    const [isHover, setIsHover] = useState(false);
    const { isMobile } = useDeviceDetect();
    const iconSize = isMobile ? PublicPortalTheme.icons.sizeM : PublicPortalTheme.icons.sizeL;
    const color = PublicPortalTheme.palette.primary.main;

    if (!props.userId) {
        return null;
    }

    return (
        <Tooltip title={props.tooltipMessage}>
            <IconButton className="custom-bookmark-button" onClick={props.action} onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                {isHover && !isMobile ? (
                    <FontAwesomeIcon icon={faBookmarkOnHover} color={color} style={iconSize} />
                ) : (
                    <FontAwesomeIcon icon={faBookmark} color={color} style={iconSize} />
                )}
            </IconButton>
        </Tooltip>
    );
});

export default SaveBookmark;
export type { BookmarkProps };
